import React, { forwardRef } from 'react'

import FormattedInput, { BaseFormattedInputProps } from '../Input/FormattedInput'

export type SsnInputVariant = 'FULL' | 'LAST_FOUR'

export interface SsnInputProps extends BaseFormattedInputProps {
  variant: SsnInputVariant
}

const FULL_SSN_TEMPLATE = '###-##-####'
const LAST4_TEMPLATE = '####'
const SsnInput = forwardRef<HTMLInputElement, SsnInputProps>(({ variant, placeholder, ...restProps }, ref) => {
  const template = variant === 'LAST_FOUR' ? LAST4_TEMPLATE : FULL_SSN_TEMPLATE

  return (
    <FormattedInput
      {...restProps}
      ref={ref}
      template={template}
      placeholder={placeholder || template}
      showTemplateInInput={true}
    />
  )
})

SsnInput.displayName = 'SsnInput'

export default SsnInput
